var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTwitterComment(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 11,
    viewBox: "0 0 10 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Comment Stroke Icon",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.27867 7.64662C4.46044 7.64662 4.60779 7.79896 4.60779 7.98689V9.31935C6.41717 8.2267 7.50579 7.45374 8.16232 6.77886C8.54332 6.38722 8.75289 6.05323 8.87461 5.73475C8.99699 5.41453 9.05102 5.05674 9.05102 4.58411C9.05102 2.89273 7.72482 1.5216 6.08887 1.5216H3.78497C2.14902 1.5216 0.82282 2.89273 0.82282 4.58411C0.82282 6.27548 2.14902 7.64662 3.78497 7.64662H4.27867ZM4.60779 10.3027C8.99447 7.6927 9.87384 6.62367 9.87384 4.58411C9.87384 2.4229 8.17925 0.670898 6.08887 0.670898H3.78497C1.69459 0.670898 0 2.4229 0 4.58411C0 6.74531 1.69459 8.49731 3.78497 8.49731V10.2046C3.78497 10.4649 4.05615 10.6287 4.27491 10.4998C4.38806 10.4331 4.499 10.3675 4.60779 10.3027Z",
    fill: "#777777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTwitterComment);
export default __webpack_public_path__ + "static/media/twitterComment.b97f5850877dc753b09ce4e9a438ee16.svg";
export { ForwardRef as ReactComponent };